// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapIcon } from '../../../../dsl/front';
/**
 * @emits click
 *
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
let ArticleSocial = class ArticleSocial extends Vue {
    get mappedIcon() {
        if (this.icon === 'twitter') {
            return 'x';
        }
        return this.icon;
    }
    /**
     * Handles `@click` event on the `<button>`.
     */
    onClick() {
        this.$emit('click');
    }
};
__decorate([
    Prop({ type: String, required: true })
], ArticleSocial.prototype, "icon", void 0);
ArticleSocial = __decorate([
    Component({
        name: 'ArticleSocial',
        components: { BootstrapButton, BootstrapIcon },
        template: `
    <BootstrapButton class="article-social btn-secondary btn-small btn-square" @click="onClick">
      <BootstrapIcon :name="mappedIcon" size="medium" />
    </BootstrapButton>
  `
    })
], ArticleSocial);
export { ArticleSocial };
export default ArticleSocial;
